import type { OrganizationSelection } from './types';

const organizationSwitchUrl = '/api/organization/switch';
const switchFailedMessage = 'Could not switch organization';
const sessionGoneMessage = 'Your session has expired. Please sign in again.';

export class OrganizationSwitchRefused extends Error {
  public readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'OrganizationSwitchRefused';
    this.status = status;
  }
}

export function getSwitchFailureMessage(error: unknown): string {
  let message = switchFailedMessage;
  if (error instanceof OrganizationSwitchRefused) {
    message = error.message;
  }
  return message;
}

export function isSessionRefusal(error: unknown): boolean {
  return error instanceof OrganizationSwitchRefused && error.status === 401;
}

async function readMessage(response: Response): Promise<string> {
  let message = '';
  try {
    const body = (await response.json()) as { message?: unknown };
    if (typeof body.message === 'string') {
      message = body.message;
    }
  } catch {} // A refusal without a JSON body carries no reason
  return message;
}

export async function switchOrganization(selection: OrganizationSelection): Promise<void> {
  const response = await fetch(organizationSwitchUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ name: selection.name, precedence: selection.precedence }),
  });
  if (!response.ok) {
    let message = await readMessage(response);
    if (response.status === 401 && message.length === 0) {
      message = sessionGoneMessage;
    }
    if (response.status < 500 && message.length > 0) {
      throw new OrganizationSwitchRefused(response.status, message);
    }
    throw new Error(`Failed to switch organization: ${response.status}`);
  }
}
